import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { TrendData } from '../../../../types/dashboard.types';
import { useTheme } from '../../../theme/ThemeProvider';
import Card from '../../../components/ui/Card/Card';
import { cardStyles } from '../../../components/ui/Card/Card';
import { axisTheme, chartColors, tooltipStyle, tooltipText } from '../chartTheme';

interface LoadsTrendCardProps {
  data?: TrendData[];
}

const formatDay = (d: string) => {
  const date = new Date(d);
  if (Number.isNaN(date.getTime())) return d;
  return date.toLocaleDateString('en-US', { day: '2-digit', month: 'short' });
};

const LoadsTrendCard: React.FC<LoadsTrendCardProps> = ({ data = [] }) => {
  const { resolvedTheme } = useTheme();
  const { axis, grid } = axisTheme(resolvedTheme);

  const chartData = data.map((d) => ({
    date: formatDay(d.date),
    Delivered: d.delivered,
    'In Transit': d.in_transit,
    'Total Created': d.total_loads,
  }));

  return (
    <Card>
      <div className={cardStyles.header}>
        <h3 className={cardStyles.title}>Loads Trend - Last 30 Days</h3>
      </div>
      <ResponsiveContainer width="100%" height={260}>
        <LineChart data={chartData} margin={{ top: 6, right: 8, left: -18, bottom: 0 }}>
          <CartesianGrid stroke={grid} vertical={false} />
          <XAxis
            dataKey="date"
            tick={{ fill: axis, fontSize: 10 }}
            tickLine={false}
            axisLine={{ stroke: grid }}
            interval="preserveStartEnd"
            minTickGap={12}
          />
          <YAxis
            tick={{ fill: axis, fontSize: 11 }}
            tickLine={false}
            axisLine={false}
            width={40}
          />
          <Tooltip
            contentStyle={tooltipStyle(resolvedTheme)}
            labelStyle={tooltipText(resolvedTheme)}
            itemStyle={tooltipText(resolvedTheme)}
          />
          <Legend iconType="plainline" wrapperStyle={{ fontSize: 12, color: axis }} />
          <Line
            type="monotone"
            dataKey="Delivered"
            stroke={chartColors.delivered}
            strokeWidth={2}
            dot={{ r: 2 }}
            activeDot={{ r: 4 }}
          />
          <Line
            type="monotone"
            dataKey="In Transit"
            stroke={chartColors.inTransit}
            strokeWidth={2}
            dot={{ r: 2 }}
            activeDot={{ r: 4 }}
          />
          <Line
            type="monotone"
            dataKey="Total Created"
            stroke={chartColors.totalCreated}
            strokeWidth={2}
            dot={{ r: 2 }}
            activeDot={{ r: 4 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </Card>
  );
};

export default LoadsTrendCard;
